import { firstView } from "../../Actions/Information/InformationActions.tsx";
import { getAuthenticatedViewer, userLoaded } from "../../Actions/Users/UserActions";
import { USER_LOGOUT } from "../../Actions/Users/UserVariables";
import { subscribeToOption } from "../../Utilities/Platform/Options/Options";
import { Application } from "../Application";
import { Bootstrapper } from "../Bootstrapper";
import type { ShopfrontDispatch } from "../hooks";

export class AuthenticationBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        // Handle what occurs when the user is logged out (or in) in a different tab
        subscribeToOption("loggedout", (_, newValue, oldValue) => {
            if(newValue && !oldValue) {
                // Set the user as logged out in the redux store
                Application.get("Redux").dispatch({
                    type: USER_LOGOUT,
                });
            } else if(oldValue && !newValue) {
                // Get the new user
                getAuthenticatedViewer()
                    .then(viewer => {
                        // Check to see if it is the first login for the page
                        const store = Application.get("Redux");
                        const state = store.getState();

                        if(state.information.firstVisit) {
                            store.dispatch(firstView());
                        }

                        // Set the new authenticated user
                        (store.dispatch as ShopfrontDispatch)(userLoaded(viewer));
                    })
                    .catch(err => {
                        console.error("Failed to load authenticated user", err);
                    });
            }
        });
    }
}
